<template>
    <div class="competition-page">
        <MaintenanceChecker
            :checkedParts="maintenance.checkedParts"
            :isInMaintenance="isInMaintenance"
        >
            <template #message>
                <div class="maintenance-mode__offer">
                    <SdsIllustration illustrationName="maintenance" />
                    <div class="maintenance-mode__offer-copy">
                        {{ $t(maintenance.message) }}
                    </div>
                </div>
            </template>
            <template #default>
                <SpinnerContainer v-if="!isStructFetched" />
                <SdsCompetitionContainer
                    v-else
                    @oddClick="onOddClick"
                />
            </template>
        </MaintenanceChecker>
    </div>
</template>
<script>
    import { SdsIllustration } from '@superbet-group/web.lib.ui-components';
    import {
        MaintenanceType,
        SelectionSourceScreen,
    } from '@superbet-group/web.types';
    import {
        mapActions,
        mapGetters,
    } from 'vuex';

    export default {
        name: 'CompetitionPageOld',
        created() {
            this.maintenance = {
                checkedParts: [MaintenanceType.Prematch, MaintenanceType.Live],
                message: 'Part of the offer is unavailable during this maintenance',
            };
        },
        computed: {
            ...mapGetters('data/maintenance', [
                'isInMaintenance',
            ]),
            ...mapGetters('data/sportOffer', [
                'isStructFetched',
            ]),
        },
        methods: {
            ...mapActions('ui/sportOffer/betSlip', [
                'toggleSelection',
            ]),
            onOddClick({ eventId, odd }) {
                const { id: oddId, specialBetValue } = odd;

                this.toggleSelection({
                    eventId,
                    oddId,
                    specialBetValue,
                    sourceScreen: SelectionSourceScreen.CompetitionDetailsOffer,
                });
            },
        },
        components: {
            SdsIllustration,
            SdsCompetitionContainer: () => import('@sportOfferFederation/competitions/components/SdsCompetitionContainer.vue'),
        },
    };
</script>
